(function (Translator) {
    // ro
    Translator.add("administration.user_search_button", "C\u0103utare", "EvpAdministrationBundle", "ro");
    Translator.add("administration.user_search_label", "ID utilizator", "EvpAdministrationBundle", "ro");
    Translator.add("forbidden", "Nu este acceptat", "EvpAdministrationBundle", "ro");
    Translator.add("internal_server_error", "Eroare de server", "EvpAdministrationBundle", "ro");
    Translator.add("invalid_code", "Cod invalid", "EvpAdministrationBundle", "ro");
    Translator.add("invalid_grant", "Acces interzis", "EvpAdministrationBundle", "ro");
    Translator.add("invalid_parameters", "Parametri invalizi", "EvpAdministrationBundle", "ro");
    Translator.add("invalid_request", "Cerere incorect\u0103", "EvpAdministrationBundle", "ro");
    Translator.add("invalid_state", "Status invalid", "EvpAdministrationBundle", "ro");
    Translator.add("limits_exceeded", "Limita atins\u0103", "EvpAdministrationBundle", "ro");
    Translator.add("logout", "Deconectare", "EvpAdministrationBundle", "ro");
    Translator.add("not_acceptable", "Nu este acceptat", "EvpAdministrationBundle", "ro");
    Translator.add("not_found", "Nu a fost g\u0103sit", "EvpAdministrationBundle", "ro");
    Translator.add("pagination.first", "Primul", "EvpAdministrationBundle", "ro");
    Translator.add("pagination.last", "Ultimul", "EvpAdministrationBundle", "ro");
    Translator.add("pagination.next", "Urm\u0103torul", "EvpAdministrationBundle", "ro");
    Translator.add("pagination.page_out_of", "formular", "EvpAdministrationBundle", "ro");
    Translator.add("pagination.previous", "\u00cenapoi", "EvpAdministrationBundle", "ro");
    Translator.add("rate_limit_exceeded", "Limita atins\u0103", "EvpAdministrationBundle", "ro");
    Translator.add("unauthorized", "Acces interzis", "EvpAdministrationBundle", "ro");
})(Translator);
